import { Button, Grid } from '@mui/material';
import { styles } from './styles';
import { commonStyles } from '~/theme/styles/commonStyles';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface ITableActionButtonsProps {
  addClick: () => void;
  removeClick: () => void;
  showRemove: boolean;
  shownAppend?: boolean;
  blockName?: string;
}

export const TableActionButtons = ({
  addClick,
  removeClick,
  showRemove,
  shownAppend = true,
  blockName,
}: ITableActionButtonsProps) => {
  return (
    <Grid
      size={{ md: 1, sm: 12, xs: 12 }}
      sx={(theme) => ({
        ...styles.item(theme),
        ...styles.actionBtnsContainer(theme),
      })}
    >
      {shownAppend && (
        <Button
          onClick={addClick}
          sx={commonStyles.actionButton}
          data-testid={`${blockName}.add-button`}
        >
          <AddIcon sx={styles.actionBtnIcon} />
        </Button>
      )}
      {showRemove && (
        <Button
          onClick={removeClick}
          sx={commonStyles.actionButton}
          data-testid={`${blockName}.delete-button`}
        >
          <RemoveIcon sx={styles.actionBtnIcon} />
        </Button>
      )}
    </Grid>
  );
};
